import { Component, OnInit } from '@angular/core';
import { DataModelService } from '@services/data-model.service';
import { Router } from '@angular/router';
import { FontawesomeListService } from '@scaffold/services/fontawesome-list.service';
import { NotificationsService } from '@services/notifications.service';
import { NbIconConfig } from '@nebular/theme';

@Component({
  selector: 'app-new-data-category',
  templateUrl: './new-data-category.component.html',
  styleUrls: ['../data-model-prefs/data-model-prefs.component.scss', './new-data-category.component.scss']
})
export class NewDataCategoryComponent implements OnInit {

  newCat = "";
  catList = [];
  previewList = [];
  iconCategories = [];
  selectedIcon

  selectedCategory

  constructor(private dataModelService: DataModelService, private router: Router, private notifications: NotificationsService, private icons: FontawesomeListService) { }

  ngOnInit() {
    this.iconCategories = this.icons.catagories;
    this.getCategories();

    this.dataModelService.updateTypeListTrigger().subscribe(() => {
      this.getCategories();
    })
  }

  getCategories() {
    this.dataModelService.getCategories().subscribe(list => {
      this.catList = list;
    })
  }

  getIconHtml(icon) {
    return '<i class="' + icon + '"></i>'
  }
  /**
 * Convert FontAwesome icon class to a nBicon definition
 * @param iconClass FontAweseome icon class
 */
  getIconDetails(iconClass: string): NbIconConfig {
    if (iconClass) {
      let details = iconClass.split(/\s/);
      if (details && details.length > 1) {
        let icon = {
          pack: details[0],
          icon: details[1].replace(/fa-/, "")
        }
        return icon
      } else {
        return null;
      }
    } else {
        return null;
      }
  }
  createCategory() {
    if (!this.alreadyExists() && this.newCat != "") {
      this.dataModelService.createCategory(this.newCat, this.selectedIcon).subscribe(data => {
        if (data.errorMessage) {
          this.notifications.popNotification(data.errorMessage, 'X');
        } else {
          this.newCat = "";
          this.selectedIcon = null;
          this.selectedCategory = null;

          this.dataModelService.updateTypes();
          // this.router.navigateByUrl('/data-models');
        }
      })
    }
  }

  alreadyExists() {
    var catExists = false;

    for (var i = 0; i < this.catList.length; i++) {
      var cat = this.catList[i];

      if (this.newCat + '__c' == cat.title) {
        catExists = true;
        break;
      }
    }

    return catExists;
  }

  previewCat() {
    if (this.newCat && this.selectedIcon) {
      this.previewList = [
        {
          title: this.newCat,
          icon: this.getIconDetails(this.selectedIcon),
          children: [
            {title:"Item 1"},{title:"Item 2"}
          ]
        }
      ]
    }
  }

}
